export default __webpack_public_path__ + "static/redsummit-3cafb737e8081794784fcf89e410ae34.png";